import { useParams } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import useBackups from '../../hooks/useBackups';
import Loader from '../../components/Loader';
import MembersButton from '../../components/MembersButton';
import useWorkspaces from '../../hooks/useWorkspaces';
import { Container, Header } from './styles';
import BackupsTable from '../../components/BackupsTable';

export default function WorkspacePage() {
  const { id } = useParams();
  const { setId, workspace } = useWorkspaces();
  const { isLoading, backups } = useBackups();

  useEffect(() => {
    setId(id);

    return () => setId(null);
  }, [id]);

  const workspaceBackups = useMemo(
    () => backups?.filter((backup) => backup.workspaceId === id),
    [backups, id],
  );

  if (isLoading || !workspace) {
    return <Loader />;
  }
  const { name, members } = workspace;
  return (
    <Container>
      <Header>
        <h1>
          {name}
        </h1>
        <MembersButton workspace={workspace} workspaceAlreadySelected />
      </Header>
      <BackupsTable backups={workspaceBackups} members={members} />
    </Container>
  );
}
